import { MetafieldReferenceShopify } from '@qlevr/shared/schema';

export function getMetafieldReferenceImage(images: MetafieldReferenceShopify): string | null {
  if (!images || !('image' in images) || images.image?.url === undefined) {
    return null;
  }

  return images.image.url;
}